import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_53_0 = () => {
  return (
    <div>
      <PageTitle title='3.53.0' />

      <ParaTitle paraTitle='Administrative Updates' />
      <Paragraph paragraph='2026-07-31' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Managers List
          <p>
            Added a centralized list of managers across all facilities, including their email addresses.
            The list can be exported to help users quickly identify and contact the appropriate personnel.
          </p>
        </li>
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>
          Report Formatting
          <p>
            Updated the formatting of the Event Summary, Event Summary with Comments, and Question Summary
            Reports to align with the Feedback Report design and provide a more consistent reporting experience.
          </p>
        </li>

        <li>
          DataTables JS Dependencies
          <p>
            Updated DataTables JS and Buttons HTML5 to the latest versions to improve functionality and
            simplify CSV and PDF export capabilities.
          </p>
        </li>
      </ul>

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
          Reviewer Assignment List Bug
          <p>
            Fixed an issue where reviewers assigned to multiple facilities did not appear in the available
            reviewer list.
          </p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.54.0', link: '/updates/3.54.0' },
          next: { name: 'Events Summary', link: '/general/events-summary' }
        }}
      />
    </div>

  )
}

export default Updates_3_53_0;